module.exports = __webpack_public_path__ + "files/e4f631777a359f41c8a14e141bc3fcd2.png";